import React, {Component} from "react";
import styled from "styled-components";
import Switch from "@material-ui/core/Switch";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {LAYER_TITLE} from "../../text.js";
import {Grid, withWidth} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/es/FormLabel/FormLabel";
import HelpIcon from "@material-ui/icons/Help";

const SwitchLayersContainer = styled.div`
    height: auto;
`;

const SwitchContainerPanel = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
`;

const SwitchContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

const style = theme => ({
        selecteurDeCouche: {
            display: 'none',
        },
        selecteurDeCoucheOpen: {
            display: 'flex',
            flexDirection: 'row-reverse',
        },
        switchContainerPanel: {
            display: 'flex',
            width: 'auto',
            [theme.breakpoints.up(750)]: {
                display: 'block',
                width: '100%',
            }
        },
        expansionPanel: {
            borderRadius: '4px',
        },
        switchCouche: {
            bottom: '2em',
            cursor: 'pointer',
            textAlign: 'right',
            position: 'absolute',
            right: '6em',
            backgroundColor: '#156bb4',
            borderRadius: '0.5em',
            padding: '0.6em',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
        },
        couchesSelecteurs: {
            width: '100%',
            [theme.breakpoints.up(499)]:
                {
                    display: 'flex',
                }
        },
        switchMasquerCouche: {
            cursor: 'pointer',
            margin: '0.1em',
            color: 'rgb(14, 74, 125)',
        },
        switchCoucheOpen: {
            display: 'none',
        },
        expandOpen: {
            transform: 'rotate(180deg)',
        },
        switchContainer: {
            cursor: 'pointer',
            height: '25'
        },
        fibre_dediee: {
            '&$colorChecked': {
                color: "rgb(1, 51, 153)",
                '& + $colorBar': {
                    backgroundColor: "rgb(1, 51, 153)",
                },
            },
        },
        fibre_mutualisee: {
            '&$colorChecked': {
                color: "rgb(0, 86, 27)",
                '& + $colorBar': {
                    backgroundColor: "rgb(0, 86, 27)",
                },
            },
        },
        mobile_4g: {
            '&$colorChecked': {
                color: "rgb(226, 114, 91)",
                '& + $colorBar': {
                    backgroundColor: "rgb(226, 114, 91)",
                },
            },
        },
        cuivre: {
            '&$colorChecked': {
                color: "rgb(255, 127, 0)",
                '& + $colorBar': {
                    backgroundColor: "rgb(255, 127, 0)",
                },
            },
        },
        colorBar: {},
        colorChecked: {},

    })
;

class SwitchLayers extends Component {
    handleChange = layer => event => {

        if (!layer.visibility)
            this.props.handleLayerVisibility(layer.id, true);
        else
            this.props.handleLayerVisibility(layer.id, false);
    };

    render() {
        const {geojson, classes, helpAction} = this.props;

        return (
            <SwitchLayersContainer>
                <ExpansionPanel className={classes.expansionPanel} defaultExpanded>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography color={"primary"} variant={"subtitle1"}>
                            {LAYER_TITLE}
                        </Typography>
                        <Grid container justify="flex-end">
                            <HelpIcon style={{color: '#006eb7'}} onClick={(event) => { event.stopPropagation(); return helpAction(); }} />
                        </Grid>
                    </ExpansionPanelSummary>

                    <ExpansionPanelDetails>
                        <SwitchContainerPanel className={classes.switchContainerPanel}>
                            {geojson &&
                            geojson.layers &&
                            geojson.layers.map(layer => (
                                <SwitchContainer
                                    key={layer.id}
                                    className={classes.switchContainer}
                                    onClick={this.handleChange(layer)}
                                >
                                    <d-iv
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                            height: 30,
                                            flexDirection: "row",
                                        }}
                                    >
                                        <Switch
                                            checked={layer.visibility}
                                            value={layer.id}
                                            classes={{
                                                switchBase: classes[layer.id],
                                                checked: classes.colorChecked,
                                                bar: classes.colorBar,
                                            }}
                                        />
                                        <FormLabel
                                            onClick={this.handleChange(layer)}
                                            style={{width: "100%"}}
                                        >
                                            {layer.name}
                                        </FormLabel>

                                    </d-iv>
                                </SwitchContainer>
                            ))}
                        </SwitchContainerPanel>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </SwitchLayersContainer>
        );
    }
}

export default withWidth()(withStyles(style)(SwitchLayers));
